'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = ScrollWatcher;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

function ScrollWatcher() {
	window.addEventListener('scroll', function (e) {
		_pubsub2['default'].emit('window:scroll', window.scrollY);
	});
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9iYWJlL1dvcmsvdG91cmhla2xhLnVsdHJhbm9pci5jb20vYXNzZXRzL3NjcmlwdHMvcGFydGlhbHMvc2Nyb2xsLXdhdGNoZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7cUJBR3dCLGFBQWE7Ozs7c0JBSGxCLFFBQVE7Ozs7NEJBQ0wsZUFBZTs7OztBQUV0QixTQUFTLGFBQWEsR0FBSTtBQUN4QyxPQUFNLENBQUMsZ0JBQWdCLENBQUMsUUFBUSxFQUFFLFVBQVMsQ0FBQyxFQUFFO0FBQzdDLHNCQUFPLElBQUksQ0FBQyxlQUFlLEVBQUUsTUFBTSxDQUFDLE9BQU8sQ0FBQyxDQUFBO0VBQzVDLENBQUMsQ0FBQTtDQUNGIiwiZmlsZSI6Ii9Vc2Vycy9iYWJlL1dvcmsvdG91cmhla2xhLnVsdHJhbm9pci5jb20vYXNzZXRzL3NjcmlwdHMvcGFydGlhbHMvc2Nyb2xsLXdhdGNoZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgcHVic3ViIGZyb20gJ3B1YnN1Yic7XG5pbXBvcnQgY2xhc3NMaXN0IGZyb20gJ2RvbS1jbGFzc2xpc3QnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBTY3JvbGxXYXRjaGVyICgpIHsgXG5cdHdpbmRvdy5hZGRFdmVudExpc3RlbmVyKCdzY3JvbGwnLCBmdW5jdGlvbihlKSB7XG5cdFx0cHVic3ViLmVtaXQoJ3dpbmRvdzpzY3JvbGwnLCB3aW5kb3cuc2Nyb2xsWSlcblx0fSlcbn0iXX0=